import { Job } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import CompanyLogo from '../atoms/CompanyLogo'
import DropdownString from '../molecules/DropdownString'
import { PeopleIcon } from '../atoms/JobBoardIcons/JobBoardIcons'

const JobCompanyInfo = ({ job }: { job: Job }) => {
  const { t } = useTranslation('common')
  const count = job.city?.split(',').length
  return (
    <>
      <div className='md:flex'>
        <div className='w-44 md:w-1/5'>
          {job.company.published ? (
            <a
              href={`/companies/profiles/${job.company.id}`}
              target='_blank'
              rel='noreferrer'
            >
              <CompanyLogo
                url={job.company.logo?.url}
                className='h-12  md:h-28'
                alt={job.company.name}
              />
            </a>
          ) : (
            <CompanyLogo
              url={job.company.logo?.url}
              className='h-12  md:h-28'
              alt={job.company.name}
            />
          )}
        </div>
        <div className='md:pl-6 md:w-4/5'>
          {job.company.published ? (
            <a
              href={`/companies/profiles/${job.company.id}`}
              target='_blank'
              rel='noreferrer'
            >
              <h2 className='text-2xl md:text-c22 leading-6 font-medium text-gray-500 mt-6 mb-4 md:mt-5 md:mb-2'>
                {job.company.name}
              </h2>
            </a>
          ) : (
            <h2 className='text-2xl md:text-c22 leading-6 font-medium text-gray-500 mt-6 mb-4 md:mt-5 md:mb-2'>
              {job.company.name}
            </h2>
          )}
          <div className='md:flex items-center'>
            {job.city && (
              <DropdownString
                icon
                limit={2}
                list={job.city.split(',')}
                className='mb-3 md:mb-0'
              />
            )}

            {job.company.employees && (
              <>
                <PeopleIcon
                  width={20}
                  height={20}
                  className='text-gray-300 md:ml-4 mr-2'
                />
                {job.company.employees}
              </>
            )}
          </div>
        </div>
      </div>
      <div>
        {job.company.history && (
          <div
            className='content mt-6 -mb-6 font-normal text-sm leading-normal'
            dangerouslySetInnerHTML={{ __html: job.company.history }}
          />
        )}
      </div>
      <div className='pt-12'>
        {job.company.activeOffersCount ? (
          <a
            href={`/companies/jobs/s/company,${job.company.id}`}
            rel='nofollow'
            className='border rounded-full pl-4 pr-2 py-2 bg-white duration-200 hover:bg-purple hover:border-purple hover:text-white w-full md:w-auto block md:inline-block text-center text-xl md:text-base'
          >
            {t('common:job_offers')}{' '}
            <span className='bg-purple rounded-full font-normal leading-5 inline-block text-white text-xs px-2 pt-1.5 pb-0.5 ml-2'>
              {job.company.activeOffersCount}
            </span>
          </a>
        ) : null}
        {job.company.activeOffersCount && job.company.published ? (
          <a
            href={`/companies/profiles/${job.company.id}`}
            rel='nofollow'
            className='border rounded-full px-4 py-2 bg-white hover:text-white duration-200 hover:bg-purple hover:border-purple md:ml-5 mt-3 md:mt-0 w-full md:w-auto block md:inline-block text-center text-xl md:text-base'
          >
            {t('common:company_profile')}
          </a>
        ) : null}
      </div>
    </>
  )
}

export default JobCompanyInfo
